// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationIsExistingUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationIsExistingUserResponse.attributeTypeMap;
    }
}
AuthenticationIsExistingUserResponse.discriminator = undefined;
AuthenticationIsExistingUserResponse.additionalProperties = false;
AuthenticationIsExistingUserResponse.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "AuthenticateStatus"
    },
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=authenticationIsExistingUserResponse.js.map